import { soloSubKey } from './utils.js'

export function selectionInfo(handles, current, sources, classified) {
  const groups = new Map()
  for (const handle of handles) {
    const entity = current.get(handle)
    if (!entity) continue
    const source = sources.get(handle)
    const cls = classified ? String(entity.layer ?? '0') : null
    const layer = classified
      ? (entity.source_layer_name ?? source?.original_layer_name ?? entity.original_layer_name ?? (entity.isUserDrawn ? 'Created in editor' : 'Unknown'))
      : String(entity.layer ?? '0')
    const subKey = soloSubKey(cls, entity.original_layer_name || entity.layer)
    const key = JSON.stringify([cls, layer, subKey])
    const row = groups.get(key) ?? { cls, layer, subKey, count: 0 }
    row.count++
    groups.set(key, row)
  }
  return [...groups.values()]
}
